import React from "react";
import { SelectInput, useGetList, useNotify, useRefresh } from "react-admin";
// MUI Button keeps its label on mobile; react-admin's collapses to an icon.
import { Button, Typography } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import dataProvider from "server/dataProvider";
import { HealthcareApplicationStatus } from "utils/constants";
import { specialistRequests } from "api/specialistApi";

const STATUS_TRANSITIONS = {
  [HealthcareApplicationStatus.Submitted]: [HealthcareApplicationStatus.Approved, HealthcareApplicationStatus.Rejected],
  [HealthcareApplicationStatus.Approved]: [HealthcareApplicationStatus.Completed],
};

const ChangeStatusDialog = ({ campaignId, applicationId, currentStatus, currentStatusName }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const { data: statuses = [] } = useGetList(specialistRequests.getHealthcareCampaignApplicationStatusesSelect(), {});

  const allowedIds = STATUS_TRANSITIONS[currentStatus] ?? [];
  const filteredStatuses = statuses.filter(s => allowedIds.includes(s.id));

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      specialistRequests.updateHealthcareCampaignApplicationStatus(campaignId, applicationId),
      { statusId: data.statusId },
      "PUT",
    );
    notify("Статусът на кандидатурата е сменен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={"Смяна на статус на кандидатура"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          size="small"
          startIcon={<AutorenewIcon />}
          disabled={allowedIds.length === 0}
        >
          Статус
        </Button>
      }
    >
      <Typography sx={{ mb: 2 }}>
        Текущ статус: <strong>{currentStatusName}</strong>
      </Typography>
      <SelectInput
        source="statusId"
        label="Статус"
        choices={filteredStatuses}
        optionText="nameBg"
        emptyText={false}
      />
    </FormModal>
  );
};

export default ChangeStatusDialog;
